// @flow

import React from "react"
import { render } from "react-dom"
import { Provider } from "react-redux"
import { ConnectedRouter } from "react-router-redux"
import store, { history } from "./store"
import Routes from "./router"
import { ThemeProvider } from "react-css-themr"
import * as Sentry from "@sentry/browser"

import theme from "./assets/react-toolbox/theme.js"

import "style-loader!css-loader!./assets/react-toolbox/theme.css"

import "normalize.css"

const target = document.querySelector( "#root" )

if ( process.env.NODE_ENV !== "development" ) {
  Sentry.init( {
    dsn: "https://6c233907c65c48e6b175f3c359b9354c@sentry.io/1219223",
  } )
}

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ThemeProvider theme={theme}>
        <Routes />
      </ThemeProvider>
    </ConnectedRouter>
  </Provider>,
  target
)



// WEBPACK FOOTER //
// ./src/index.jsx